module.exports = __webpack_public_path__ + "static/media/wbgr2_.05e1b1c1.svg";